﻿import { _tyreDetailsSummaryPanel } from './tyre-details-summary.js';
import { _data, VehicleClassWheelPlan, CustomerModel } from './data.tyre.js';
import { _vehiclePanel } from './tyre-vehicle.js';
import { _driverPanel } from './tyre-driver.js';
import { _bookingPanel } from './tyre-booking-details.js';
import { _wheelDetailsPanel } from './tyre-wheel-details.js';
import { _utilities } from '../utilities.js';
import Common from '../i247.Common.js';
import { _mapping } from '../i247.Mapping.js';
import { _address } from '../i247.Address.js';
import { _wheelPlansPanel } from './wheelplans.js';
import { _tyreConfigurationPanel } from './tyreconfiguration.js';
import { _jobLocation } from './jobLocation.js';
import { _tyresForm } from '../i247.VehicleLookup.js';

class TyresForm {
	constructor() {
		kendo.ui.progress($('body'), true);
		this.vehicleViewModel = null;
		this.navigationTexts = ['Vehicle Search', 'Vehicle', 'Tyre Selection', 'Passenger Front', 'Driver Front', 'Passenger Rear', 'Driver Rear', 'Passenger Rear 2', 'Driver Rear 2', 'Tyre Selection Summary', 'Wheel Details', 'jobLocationNavigationText', 'Booking', 'Driver', 'Summary', 'Confirmation'];
		this.navigatingForward = true;
		this.sections = {
			collection: [
				// searchDetail
				{
					name: 'searchDetail',
					index: 1,
					dom: $('#searchDetails'),
					type: 'section',
					active: false,
					disabled: false,
					onOpen: () => {
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '1: enter registration' });
					},
					onExit: () => {
					}
				},
				// vehicleDetail
				{
					name: 'vehicleDetail',
					anchor: 'vehicleDetailsAnchor',
					index: 2,
					dom: $('#vehicleDetailsSection'),
					type: 'section',
					active: false,
					disabled: false,
					onOpen: () => {
						$('.toast').toast();
						$($('.mobile-breadcrumb-nav li')[0]).addClass('active');
						$('#Mileage').focus();
						this.bindButtons();
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '2: vehicle detail' });
					},
					onExit: () => {
						_vehiclePanel.SaveVehicleDetails();
					},
                    validator: () => {
                        var mileageNotRequired = $('#mileageInput').is(':hidden');
                        if (mileageNotRequired) {
                            return null;
                        }
						return Common.GetVehicleValidator();
					}
				},
				// wheelPlan
				{
					name: 'wheelPlan',
					anchor: 'wheelPlanAnchor',
					index: 3,
					dom: $('#wheelPlanSection'),
					type: 'section',
					active: false,
					disabled: false,
					onOpen: () => {
						let model = _data.vehicle;
						if (!model._wheelPlan) {
							_wheelPlansPanel.Initialise(this.sections.disable, this.sections.enable);
						}
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '3: wheel plan' });
					},
					onExit: () => {

					},
					validator: () => {
						return _wheelPlansPanel.GetValidator();
					}
				},
				// tyres
				{
					name: 'tyres',
					anchor: 'TYRESAnchor',
					index: 4,
					dom: $('#tyreSection_TYRES'),
					type: 'section',
					active: false,
					disabled: false,
					onOpen: () => {
						_tyreConfigurationPanel.Initialise('tyres', $('#tyreSection_TYRES'), this.sections.disable, this.sections.enable, this.navigatingForward);
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '4: tyres' });
					},
					onExit: () => {
						_tyreConfigurationPanel.Save();
					},
					validator: () => {
						return _tyreConfigurationPanel.GetValidator('tyres');
					}
				},
				// tyreSummary
				{
					name: 'tyreSummary',
					anchor: 'tyreDetailsSummaryAnchor',
					index: 5,
					dom: $('#tyreDetailsSummarySection'),
					type: 'section',
					active: false,
					disabled: false,
					onOpen: () => {
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '5: tyre summary' });
						_tyreDetailsSummaryPanel.displayTyresSelection(this.sections.show, this.navigatingForward);
					},
					validator: () => {
						return _tyreDetailsSummaryPanel.GetValidator();
					}
				},
				// wheelDetail
				{
					name: 'wheelDetail',
					anchor: 'wheelDetailsAnchor',
					index: 6,
					dom: $('#wheelDetailsSection'),
					type: 'section',
					active: false,
					disabled: false,
					onOpen: () => {
						_wheelDetailsPanel.initializePanel();
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '6: wheel detail' });
					},
					onExit: () => {
						_wheelDetailsPanel.saveWheelDetails();
						// console.log(`data: ${JSON.stringify(_data)}`);
					},
					validator: () => {
						return _wheelDetailsPanel.getValidator();
					}
				},
				// jobLocation
				{
					name: 'jobLocation',
					anchor: 'jobLocationAnchor',
					index: 7,
					dom: $('#jobLocationSection'),
					type: 'section',
					active: false,
					disabled: false,
					slides: [
						{
							name: 'jobAddress',
							index: 1,
							dom: $('#jobAddressSlide'),
							type: 'slide',
							active: false,
							disable: false,
							onOpen: () => {
								_jobLocation.bindControls();
								gtag('event', 'entered', { 'event_category': 'section', 'event_label': '7: job location' });
							},
							validator: () => {
								return _jobLocation.getAddressSlideValidator();
							}
						},
						{
							name: 'depotList',
							index: 2,
							dom: $('#depotsSlide'),
							type: 'slide',
							active: false,
							disable: false,
							onOpen: () => {
								_jobLocation.initialiseDepotList(this.sections.moveNext, this.move);
								gtag('event', 'entered', { 'event_category': 'section', 'event_label': '8: depot list' });
							},
							validator: () => {
								return _jobLocation.getDepotValidator();
							},
						}
					],
					validator: () => {
						return _jobLocation.getValidator();
					},
					onExit: () => {
						_jobLocation.saveJobLocation();
					}
				},
				// bookingDetail
				{
					name: 'bookingDetail',
					anchor: 'bookingDetailsAnchor',
					index: 8,
					dom: $('#bookingDetailsSection'),
					type: 'section',
					active: false,
					disabled: false,
					onOpen: () => {
						_bookingPanel.InitializePanel(this.sections.moveNext, this.sections.moveBack, this.navigatingForward);
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '9: booking detail' });
					},
					onExit: () => {
						_bookingPanel.SaveBookingDetails();
					},
					validator: () => {
						return _bookingPanel.GetValidator();
					}
				},
				// driverDetail
				{
					name: 'driverDetail',
					anchor: 'driverDetailsAnchor',
					index: 9,
					dom: $('#driverDetailsSection'),
					type: 'section',
					active: false,
					disabled: false,
					slides: [
					{
						name: 'driverDetailForm',
						index: 1,
						dom: $('#driverDetailsSlide'),
						type: 'slide',
						active: false,
						disable: false,
						validator: _driverPanel.getDriverDetailValidator
					}],
					onOpen: () => {
						_driverPanel.InitializePanel();
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '10: driver detail' });
					},
					onExit: () => {
						_driverPanel.SaveDriverDetails();
					}
				},
				// summary
				{
					name: 'summary',
					anchor: 'summaryAnchor',
					index: 10,
					dom: $('#summarySection'),
					type: 'section',
					active: false,
					disabled: false,
					onOpen: () => {
						// Uncomment to enable developer test
						// console.log(JSON.stringify(_data));
						// _data.initSelfDevObject(your json object);
						this.buildSummary();
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '11: final summary' });
					},
					onExit: () => {
					}
				},
				// confirmation
				{
					name: 'confirmation',
					anchor: 'confirmationAnchor',
					index: 11,
					dom: $('#confirmationSection'),
					type: 'section',
					active: false,
					disabled: false,
					onOpen: () => {
						this.buildConfirmation();
						gtag('event', 'entered', { 'event_category': 'section', 'event_label': '12: confirmation' });
					},
					onExit: () => {
					}
				}
			],
			moveNext: () => {
				this.navigatingForward = true;
				const activeSection = this.sections.collection.find(section => section.active === true);
				const nextSectionsIndexList = this.sections.collection
					.filter(section => section.index > activeSection.index && section.disabled === false)
					.map(section => section.index);
				const nextSectionIndex = nextSectionsIndexList.reduce(function (prev, curr) {
					return (Math.abs(curr - activeSection.index) < Math.abs(prev - activeSection.index) ? curr : prev);
				});
				const nextSection = this.sections.collection.find(section => section.index === nextSectionIndex);
				let proceed = activeSection.validator ? this.sections.validate(activeSection, activeSection.validator()) : true;
				removeDuplicateErrorMessages();
				if (proceed) {
					_utilities.incrementBreadCrumbs(activeSection, nextSection);
					if (activeSection.name === 'summary') {
						this.createJob();
					}
					else
					{
						activeSection.onExit && activeSection.onExit();
					}

					this.sections.hide(activeSection.name);
					this.sections.show(nextSection.name);
				}
			},
			moveBack: () => {
				this.navigatingForward = false;
				let activeSection = this.sections.collection.find(section => section.active === true);

				const prevSectionsIndexList = this.sections.collection
					.filter(section => section.index < activeSection.index && section.disabled === false)
					.map(section => section.index);

				const prevSectionIndex = prevSectionsIndexList.reduce(function (prev, curr) {
					return (Math.abs(curr - activeSection.index) < Math.abs(prev - activeSection.index) ? curr : prev);
				});

				const previousSection = this.sections.collection.find(section => section.index === prevSectionIndex);

				this.sections.hide(activeSection.name);
				this.sections.show(previousSection.name);

				if ($('.nextButton').is(":hidden")) {
					$('.nextButton').show();
				}
			},
			moveTo: (sectionAnchor) => {
				let activeSection = this.sections.collection.find(section => section.active === true);
				let targetDestinationSection = this.sections.collection.find(section => section.anchor === sectionAnchor);
				this.sections.hide(activeSection.name);
				this.sections.show(targetDestinationSection.name);
			},
			show: (sectionName) => {
				let selectedSection = this.sections.collection.find(section => section.name === sectionName);
				this.sections.collection.forEach(section => {
					this.sections.hide(section.name);
				});

				selectedSection.active = true;

				//Hack to sort of navigation of slides, this assumes slides are in accending order
				if (selectedSection.slides) {
					var slideNumber = this.navigatingForward
						? 0
						: selectedSection.slides.length - 1;

					//Bad hack to deal with skipping of page
					if (!this.navigatingForward) {
						if (selectedSection.name == 'jobLocation' && (_utilities.DoNotAllowDepotSelection() || _data.bookingDetails.serviceRequired == 'M')) {
							slideNumber = 0;
						}
					}

					if (slideNumber < 0) {
						slideNumber = 0;
					}

					selectedSection.slides && this.sections.showSlide(selectedSection.slides[slideNumber].name);
				}

				selectedSection.dom.show();
				selectedSection.onOpen && selectedSection.onOpen();
			},
			hide: (sectionName) => {
				let selectedSection = this.sections.collection.find(section => section.name === sectionName);
				selectedSection.dom.hide();
				selectedSection.active = false;
			},
			slideRight: () => {
				let currentSection = this.sections.collection.find(section => section.active === true);
				let currentActiveSlide = currentSection.slides.find(slide => slide.active === true);
				let nextSlide = currentSection.slides.find(slide => slide.index === currentActiveSlide.index + 1);
				let proceed = currentActiveSlide.validator ? this.sections.validate(currentSection, currentActiveSlide.validator()) : true;
				if (proceed) {
					this.sections.hideSlide(currentActiveSlide.name);
					if (nextSlide) this.sections.showSlide(nextSlide.name);
					else this.sections.moveNext();
					currentActiveSlide.onExit && currentActiveSlide.onExit();
				}
			},
			slideLeft: () => {
				let currentSection = this.sections.collection.find(section => section.active === true);
				let currentActiveSlide = currentSection.slides.find(slide => slide.active === true);
				let prevSlide = currentSection.slides.find(slide => slide.index === currentActiveSlide.index - 1);
				if (!prevSlide) {
					this.sections.moveBack();
				} else {
					this.sections.hideSlide(currentActiveSlide.name);
					this.sections.showSlide(prevSlide.name);
					currentActiveSlide.onExit && currentActiveSlide.onExit();
				}
			},
			showSlide: (slideName) => {
				let currentSection = this.sections.collection.find(section => section.active === true);
				let selectedSlide = currentSection.slides.find(slide => slide.name === slideName);
				currentSection.slides.forEach(slide => {
					this.sections.hideSlide(slide.name);
				});
				selectedSlide.dom.show();
				selectedSlide.active = true;
				selectedSlide.onOpen && selectedSlide.onOpen();
			},
			hideSlide: (slideName) => {
				let currentSection = this.sections.collection.find(section => section.active === true);
				let selectedSlide = currentSection.slides.find(slide => slide.name === slideName);
				selectedSlide.dom.hide();
				selectedSlide.active = false;
            },            
			validate: (currentSection, validator) => {
				const containerId = currentSection.dom.prop('id');
				const isTyreDetailsSection = containerId.startsWith('tyreSection_');
				const section = currentSection.dom;

				// Validate section
				let validated = true;
				if (validator !== null) {
					Common.BindValidationStyles(validator);

					// Check if section is valid. Tyre details sections have a default
					// Kendo validator and a custom validation function
					if (isTyreDetailsSection) {
						if (!_tyreConfigurationPanel.ConfigurationIsValid()) {
							section.find('#tyreConfigurationInvalidWarning').show();
							validator.validate();
							validated = false;
						} else {
							section.find('#tyreConfigurationInvalidWarning').hide();
							validated = validator.validate();
						}
					} else if (containerId == "jobLocationSection") {
						var kendoValid = validator.validate();
						var validLocation = $("#LocationTypeWork").is(":checked")
							|| $("#LocationTypeHome").is(":checked")
							|| $("#LocationTypeTemp").is(":checked");

						var validJobType = _utilities.IsChecked('ServiceRequiredSameDayMobile')
							|| _utilities.IsChecked('ServiceRequiredRapidResponse')
							|| _utilities.IsChecked('ServiceRequiredNextDayMobile')
							|| _utilities.IsChecked('ServiceRequiredDepot')
							|| _utilities.IsChecked('ServiceRequiredMobile');

						if (validLocation) {
							$("#locationTypeError").removeClass("d-block");
							$("#locationTypeError").addClass("d-none");
						} else {
							$("#locationTypeError").removeClass("d-none");
							$("#locationTypeError").addClass("d-block");
						}

						if (validJobType) {
							$("#JobTypeError").removeClass("d-block");
							$("#JobTypeError").addClass("d-none");
						} else {
							$("#JobTypeError").removeClass("d-none");
							$("#JobTypeError").addClass("d-block");
                        }

                        var validPostcode = isValidPostcode($('#jobPostcode').val());
                        if (validPostcode) {
                            $("#PostcodeError").removeClass("d-block");
                            $("#PostcodeError").addClass("d-none");
                        } else {
                            $("#PostcodeError").removeClass("d-none");
                            $("#PostcodeError").addClass("d-block");
                        }


						validated = kendoValid && validLocation && validJobType && validPostcode;
					} else {
						validated = validator.validate();
					}
				}

				return validated;
			},
			enable: (sectionName) => {
				let section = this.sections.collection.find(section => section.name === sectionName);
				section.disabled = false;
			},
			disable: (sectionName) => {
				let section = this.sections.collection.find(section => section.name === sectionName);
				section.disabled = true;
			}
		};

		this.disableMoveNext = true;

		this.initTyrePage();
	};
	initTyrePage() {
		let _this = this;
		_this.GetCustomerData();
		kendo.culture('en-GB');
		$('.section').hide();
		_this.sections.show('searchDetail');
		_this.bindFormControls();
		_address.BindControls();
		$('#depotMobileAltAddress').hide();
		//Make sure the next button is shown if turned off by an empty wheel configuration.
		_this.SetWheelPlans();
		$('#vehicle-search-input').focus();
	};
	GetCustomerData() {
		$.get("/tyres/CustomerLink", (data) => {
			_data.customer = new CustomerModel(data.name, data.homeLink);
		});
	};
	SetWheelPlans() {
		//TODO: Revisit this logic.
		VehicleClassWheelPlan.plans = [];

		var vehicleClasses = ["car", "lcv"];
		vehicleClasses.forEach(_class => {

			let WheelPlans = [
				{ id: 1, name: "Standard Car", image: '4x2.svg' },
				{ id: 2, name: "Twin Wheel Van", image: '4x2twin.svg' },
				{ id: 21, name: "Standard Van", image: '4x2van.svg' }
			];

			VehicleClassWheelPlan.plans.push(new VehicleClassWheelPlan(_class, WheelPlans));
		});
	};
	bindButtons() {
		let _this = this;
		$('.nextButton').off();
		$('.nextButton').on('click', (_event) => {
			_this.sections.moveNext();
		});

		$('.nextButtonSlide').off();
		$('.nextButtonSlide').on('click', (_event) => {
			_this.sections.slideRight();
		});

		$('.backButton').off();
		$('.backButton').on('click', (_event) => {
			_this.sections.moveBack();
			//TO DO: This is a temporary hack to fix a bug with the wheelplans.
			if ($(this).html() === "Not My Vehicle") {
				location.reload(true);
			}
		});

		$('.backButtonSlide').off();
		$('.backButtonSlide').on('click', (_event) => {
			_this.sections.slideLeft();
		});

		$('input.submitOnEnter').on('keyup', function(event) {
			if (event.keyCode === 13) {
				event.preventDefault();
				let btn = $(this).closest('.section').find('.btn-success').not(":hidden");
				btn.trigger('click');
			}
		});
	};
	buildSummary() {
		let _this = this;

		// Vehicle
		var summaryPanel = _this.sections.collection.find(section => section.name === 'summary').dom;
		summaryPanel.find('#vehicleRegistration').text(_data.vehicle.vehicleDetails.vehicleReg);
		summaryPanel.find('#vehicleMake').text(_data.vehicle.vehicleDetails.vehicleMake);
        summaryPanel.find('#vehicleModel').text(_data.vehicle.vehicleDetails.vehicleModel);
        if (_data.vehicle.vehicleDetails.mileageCheckSuppression) {
            summaryPanel.find('#vehicleMileage').parent().hide();
        }
        else {
		summaryPanel.find('#vehicleMileage').text(_data.vehicle.vehicleDetails.vehicleMileage);
        }

		// Driver
		var driverFullName = _data.driver.title;
		if (_data.driver.firstname) {
			driverFullName += ' ' + _data.driver.firstname;
		}
		driverFullName += ' ' + _data.driver.surname;
		summaryPanel.find('#driverName').text(driverFullName);
		summaryPanel.find('#driverMobile').text(_data.driver.mobile);
		if (_data.driver.landline) {
			summaryPanel.find('#driverAlternativePhone').closest('.row').show();
			summaryPanel.find('#driverAlternativePhone').text(_data.driver.landline);
		} else {
			summaryPanel.find('#driverAlternativePhone').closest('.row').hide();
		}
		summaryPanel.find('#driverEmail').text(_data.driver.email);
		summaryPanel.find('#smsConfirmation').text(_data.driver.smsConfirmation === true ? 'Yes' : 'No');

		// Work required
		// TODO: make all html below a mustache templates;
		summaryPanel.find('#workRequiredSummary').html('<div class="row border-bottom mb-2 mt-2 text-info pt-2 summary-row"><div class="col"><label>Tyre Details</label><a href="#" class="text-muted" data-section-anchor="wheelPlanAnchor"><i class="fas fa-edit ml-2" aria-hidden="true"></i></a></div></div>');

		// Swap lines to enable developer test
		let wheelPlan = _wheelPlansPanel._wheelPlan;
		//let wheelPlan = { "NSF": { "Selected": 1, "Name": "Passenger Front", "Position": "NSF", "CheckedRadioListIds": [] }, "OSR": { "Selected": 0, "Name": "Driver Rear", "Position": "OSR", "CheckedRadioListIds": [] }, "NSR": { "Selected": 0, "Name": "Passenger Rear", "Position": "NSR", "CheckedRadioListIds": [] }, "OSF": { "Selected": 0, "Name": "Driver Front", "Position": "OSF", "CheckedRadioListIds": [] } };

		$('#workRequiredSummary').append(
			`<div class="row tyre-detail-summary-titles d-none d-md-flex">` +
			`<span class=col-md-3>&nbsp;</span>` +
			`<span class="col-md-4">Tyre Size</span> ` +
			`<span class="col-md-2">Brand</span> ` +
			`<span class="col-md-2">Damage</span> ` +
			`</div>`
		);
		_data.vehicle.tyreDetailLines.forEach(tyre => {
			_this.addTyreDetailSummary(_.assignInWith({}, tyre, {
				title: wheelPlan[tyre.wheelSelected].Name
			}), tyre.wheelSelected);
		});

		summaryPanel.find('#wheelType, #lockingWheelNuts, #roadworthySpare, #spareSize, #inflationKit, #obstructions').closest('.row').hide();

		// Wheel Details
		_data.vehicle.wheelDetails.wheelType && summaryPanel.find('#wheelType').text(_data.vehicle.wheelDetails.wheelType).closest('.row').show();
		_data.vehicle.wheelDetails.lockingWheelNuts && summaryPanel.find('#lockingWheelNuts').text(_data.vehicle.wheelDetails.lockingWheelNuts).closest('.row').show();
		_data.vehicle.wheelDetails.roadworthySpare && summaryPanel.find('#roadworthySpare').text(_data.vehicle.wheelDetails.roadworthySpare).closest('.row').show();
		_data.vehicle.wheelDetails.spareSize && summaryPanel.find('#spareSize').text(_data.vehicle.wheelDetails.spareSize).closest('.row').show();
		_data.vehicle.wheelDetails.inflationKit && summaryPanel.find('#inflationKit').text(_data.vehicle.wheelDetails.inflationKit).closest('.row').show();
		_data.vehicle.wheelDetails.obstructions && summaryPanel.find('#obstructions').text(_data.vehicle.wheelDetails.obstructions).closest('.row').show();
		if (_data.vehicle.wheelDetails.obstructionDetails) {
			summaryPanel.find('#obstructionsComment').closest('.row').show();
			summaryPanel.find('#obstructionsComment').text(_data.vehicle.wheelDetails.obstructionDetails);
		} else {
			summaryPanel.find('#obstructionsComment').closest('.row').hide();
		}

		// Address details
		var serviceRequired = _data.bookingDetails.serviceRequired;
		if (serviceRequired === 'D') {
			summaryPanel.find('#appointmentType').text('Garage Booking');

			if (_utilities.DoNotAllowDepotSelection()) {
				summaryPanel.find('#garageDetails').hide();
				summaryPanel.find('#jobLocationDetails').hide();;
			} else {
				var depot = _data.bookingDetails.depot;
				summaryPanel.find('#garageName').text(depot.name);
				summaryPanel.find('#garageAddress1').text(depot.address1);

				if (depot.address2) {
					summaryPanel.find('#garageAddress2').closest('.row').show();
					summaryPanel.find('#garageAddress2').text(depot.address2);
				} else {
					summaryPanel.find('#garageAddress2').closest('.row').hide();
				}

				summaryPanel.find('#garageTown').text(depot.town);
				var county = summaryPanel.find('#garageCounty');

				if (depot.county === '') {
					county.closest('.row').hide();
				} else {
					county.closest('.row').show();
					county.text(depot.county);
				}

				summaryPanel.find('#garagePostcode').text(depot.postcode);

				// Show correct address panel
				summaryPanel.find('#garageDetails').show();
				summaryPanel.find('#jobLocationDetails').hide();
			}
		} else if (serviceRequired === 'M') {
			// Populate job location details
			var jobLocation = _data.bookingDetails.location;
			summaryPanel.find('#jobLocationAddress1').text(jobLocation.line1);
			if (jobLocation.line2) {
				summaryPanel.find('#jobLocationAddress2').closest('.row').show();
				summaryPanel.find('#jobLocationAddress2').text(jobLocation.line2);
			} else {
				summaryPanel.find('#jobLocationAddress2').closest('.row').hide();
			}
			summaryPanel.find('#jobLocationTown').text(jobLocation.town);
			summaryPanel.find('#jobLocationCounty').text(jobLocation.county);
			summaryPanel.find('#jobLocationPostCode').text(jobLocation.postcode);

			// Show correct address panel
			summaryPanel.find('#garageDetails').hide();
			summaryPanel.find('#jobLocationDetails').show();

			var jobType = _data.bookingDetails.jobType
				? _data.bookingDetails.jobTypeName
				: 'Mobile';

			summaryPanel.find('#appointmentType').text(jobType);
		}

		if (SITE_CAN_SELECT_MULTIPLE_DATES) {
			//Job types are only currently set for mfs
			if (_data.bookingDetails.jobType && serviceRequired === 'M') {
				summaryPanel.find('#appointmentDate').closest('.row').hide();
				summaryPanel.find('#appointmentTime').closest('.row').hide();
				summaryPanel.find('#appointmentDate2').closest('.row').hide();
				summaryPanel.find('#appointmentTime2').closest('.row').hide();
				summaryPanel.find('#appointmentDate3').closest('.row').hide();
				summaryPanel.find('#appointmentTime3').closest('.row').hide();
			} else {
				// Appointment date and time
				let bookingTime = _data.bookingDetails.bookingTime === 'am' ? 'Morning' : _data.bookingDetails.bookingTime === 'pm' ? 'Afternoon' : _data.bookingDetails.bookingTime;
				summaryPanel.find('#appointmentDate').text(_data.bookingDetails.bookingDate);
				summaryPanel.find('#appointmentTime').text(bookingTime);

				let bookingTime2 = _data.bookingDetails.bookingTime2 === 'am' ? 'Morning' : _data.bookingDetails.bookingTime2 === 'pm' ? 'Afternoon' : _data.bookingDetails.bookingTime2;
				summaryPanel.find('#appointmentDate2').text(_data.bookingDetails.bookingDate2);
				summaryPanel.find('#appointmentTime2').text(bookingTime2);

				let bookingTime3 = _data.bookingDetails.bookingTime3 === 'am' ? 'Morning' : _data.bookingDetails.bookingTime3 === 'pm' ? 'Afternoon' : _data.bookingDetails.bookingTime3;
				summaryPanel.find('#appointmentDate3').text(_data.bookingDetails.bookingDate3);
				summaryPanel.find('#appointmentTime3').text(bookingTime3);

				summaryPanel.find('a').off();
				summaryPanel.find('a').on('click', function () {
					let anchor = $(this).data().sectionAnchor;
					if (anchor) {
						// Show the button that allows navigation back to summary
						let targetSection = _this.sections.collection.find(section => section.anchor === anchor).dom;
						if (targetSection.find(".back-to-summary")) {
							targetSection.find(".back-to-summary").show();
						}

						// Re-bind buttons, so that events work with dynamic tyre sections
						$('.back-to-summary').off();
						$('.back-to-summary').on('click', function (_event) {
							_this.sections.moveTo('summaryAnchor');
						});
					}
					_this.sections.moveTo(anchor);
				});
			}
		} else {
			//Job types are only currently set for mfs
			if (_data.bookingDetails.jobType && serviceRequired === 'M') {
				summaryPanel.find('#appointmentDate').closest('.row').hide();
				summaryPanel.find('#appointmentTime').closest('.row').hide();
			} else {
				// Appointment date and time
				let time = _data.bookingDetails.bookingTime === 'am' ? 'Morning' : _data.bookingDetails.bookingTime === 'pm' ? 'Afternoon' : _data.bookingDetails.bookingTime;
				summaryPanel.find('#appointmentDate').text(_data.bookingDetails.bookingDate);
				summaryPanel.find('#appointmentTime').text(time);

				summaryPanel.find('a').off();
				summaryPanel.find('a').on('click', function () {
					let anchor = $(this).data().sectionAnchor;
					if (anchor) {
						// Show the button that allows navigation back to summary
						let targetSection = _this.sections.collection.find(section => section.anchor === anchor).dom;
						if (targetSection.find(".back-to-summary")) {
							targetSection.find(".back-to-summary").show();
						}

						// Re-bind buttons, so that events work with dynamic tyre sections
						$('.back-to-summary').off();
						$('.back-to-summary').on('click', function (_event) {
							_this.sections.moveTo('summaryAnchor');
						});
					}
					_this.sections.moveTo(anchor);
				});
			}
		}
	};
	addTyreDetailSummary(tyre, anchorPosition) {
		const { title, brand, width, ratio, diameter, load, rating, construction, damageType } = tyre;
		let tyrePosition = `<div class="col-md-3"><label>${title}</label></div>`;
		$('#workRequiredSummary').append(
			`<div class="row">` +
			`${tyrePosition} <span class="col-md-4">${width}/${ratio} R${diameter} ${load} ${rating} ${construction}</span> ` +
			`<span class="col-md-2">${brand}</span>` +
			`<span class="col-md-2">${damageType.Name}</span>` +
			`</div>`
		);
	};
	buildConfirmation() {
		let _this = this;
		var $confirmationPanel = _this.sections.collection.find(section => section.name === 'confirmation').dom;

		$confirmationPanel.find('#driverTitle').text(_data.driver.title);
		$confirmationPanel.find('#driverFirstName').text(_data.driver.surname);

		if (SITE_DO_REDIRECT.toLowerCase() === 'false') {
			$confirmationPanel.find('#customerHomeLink').css('display', 'none');
		} else {
			$confirmationPanel.find('#customerHomeLink').text(`Return to ${_data.customer.name} Home`);
			$confirmationPanel.find('#customerHomeLink').attr("href", _data.customer.homeLink);
		}

		if (_data.vehicle.wheelDetails.lockingWheelNuts) {
			$confirmationPanel.find('#lockingWheelNuts').css('display', 'list-item');
		} else {
			$confirmationPanel.find('#lockingWheelNuts').css('display', 'none');
		}

		if (_data.bookingDetails.serviceRequired) {
			if (_data.bookingDetails.serviceRequired === 'D' && !_utilities.DoNotAllowDepotSelection()) {
				$confirmationPanel.find('#depotAddress').show();
				$confirmationPanel.find('#garageName').text(_data.bookingDetails.depot.name);
				$confirmationPanel.find('#garageAddress1').text(_data.bookingDetails.depot.address1);
				$confirmationPanel.find('#garageAddress2').text(_data.bookingDetails.depot.address2);
				$confirmationPanel.find('#garageTown').text(_data.bookingDetails.depot.town);
				$confirmationPanel.find('#garageCounty').text(_data.bookingDetails.depot.county);
				$confirmationPanel.find('#garagePostcode').text(_data.bookingDetails.depot.postcode);

				$confirmationPanel.find('#arriveAtDepotEarly').css('display', 'list-item');
				$confirmationPanel.find('#depotWillInspect').css('display', 'list-item');
				$confirmationPanel.find('#fitterTimeOfArrival').css('display', 'none');
				$confirmationPanel.find('#spaceForFitting').css('display', 'none');
			} else if (_data.bookingDetails.serviceRequired === 'M') {
				$confirmationPanel.find('#depotAddress').hide();
				$confirmationPanel.find('#arriveAtDepotEarly').css('display', 'none');
				$confirmationPanel.find('#depotWillInspect').css('display', 'none');
				$confirmationPanel.find('#fitterTimeOfArrival').css('display', 'list-item');
				$confirmationPanel.find('#spaceForFitting').css('display', 'list-item');
			}
		}

		$('#smsConfirmationRequested').hide();
		if ($('#CheckBoxSendSMSConfirmation').is(':checked')) {
			$('#smsConfirmationRequested').show();
		}
	};
	bindFormControls() {
		let _this = this;
		$.each(_this.sections.collection, function (index, section) {
			if (!section.anchor) return;
			var dynamicAnchors = ['NSFAnchor', 'NSRAnchor', 'OSFAnchor', 'OSRAnchor', 'NSR2Anchor', 'OSR2Anchor'];
			var isTyreDetail = dynamicAnchors.indexOf(section.anchor) > -1;
			var breadcrumbsListItem;
			breadcrumbsListItem = '<li ' + (isTyreDetail === true ? 'style="display: none;"' : '') + ' data-menuanchor="' + section.anchor + '">';
			breadcrumbsListItem += '<a href="#' + section.anchor + '">';
			breadcrumbsListItem += '<div class="d-md-none d-lg-none">' + parseInt(parseInt(index) + 1) + '</div>';
			breadcrumbsListItem += '<div class="text-center">' + _this.navigationTexts[index] + '</div>';
			breadcrumbsListItem += '</a>';
			breadcrumbsListItem += '</li>';
			$('#serviceBreadcrumb').append(breadcrumbsListItem);
		});

		_this.bindButtons();
		_utilities.BuildMobileBreadcrumbNav();

		$('#fullPageContainer').show();
		kendo.ui.progress($('body'), false);
	};
	cleanValues(value) {
		if (value) {
			if (value.toUpperCase() === 'YES') {
				value = true
			} else if (value.toUpperCase() === 'NO') {
				value = false;
			}
		}
		return value;
	};
	createJob() {
		let _this = this;

		// reset any yes/no to true/false.
		_data.vehicle.wheelDetails.lockingWheelNuts = _this.cleanValues(_data.vehicle.wheelDetails.lockingWheelNuts);
		_data.vehicle.wheelDetails.roadworthySpare = _this.cleanValues(_data.vehicle.wheelDetails.roadworthySpare);
		_data.vehicle.wheelDetails.inflationKit = _this.cleanValues(_data.vehicle.wheelDetails.inflationKit);
		_data.vehicle.wheelDetails.obstructions = _this.cleanValues(_data.vehicle.wheelDetails.obstructions);

		let vehicle = {
			WheelPlan: _data.vehicle.wheelPlan,
			WheelDetails: _data.vehicle.wheelDetails,
			VehicleDetails: _data.vehicle.vehicleDetails,
			TyreDetailLines: _data.vehicle.tyreDetailLines,
			WheelsSelected: _data.vehicle.wheelsSelected,
			Class: _data.vehicle.class,
			SubDomainCode: _data.vehicle.subDomainCode,
		}

		var bookingDetails = {
			ServiceRequired: _data.bookingDetails.serviceRequired,
			BookingDate: _data.bookingDetails.bookingDate,
			BookingTime: _data.bookingDetails.bookingTime,
			BookingDate2: _data.bookingDetails.bookingDate2,
			BookingTime2: _data.bookingDetails.bookingTime2,
			BookingDate3: _data.bookingDetails.bookingDate3,
			BookingTime3: _data.bookingDetails.bookingTime3,
			Location: _data.bookingDetails.location,
			Depot: _data.bookingDetails.depot,
			AddressType: _data.bookingDetails.addressType,
			JobType: _data.bookingDetails.jobType
		}

		let serverData = {
			driver: _data.driver,
			vehicle: vehicle,
			bookingDetails: bookingDetails
		};

		$.ajax({
			type: 'POST',
			url: '/tyres/createjob',
			data: serverData,
			success: function (data, status, xhr) {
				if (xhr.status !== 200) {
					Common.ShowGenericError();
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				Common.ShowGenericError();
			}
		});
	};

	setVehicle(vehicleIn) {
		this.vehicleViewModel = vehicleIn;
		_data.vehicle.class = vehicleIn.class;
		_data.vehicle.subDomainCode = vehicleIn.subDomainCode;
		let reg = $('#vehicle-search-input').val();
		this.vehicleViewModel.registrationNumber = reg.replace(' ','');
		$("#CustomerCompanyId").val(vehicleIn.customerCompanyId);
	};
	initialiseVehicleModel() {
		let _this = this;
		$('#VehicleID').val(_this.vehicleViewModel.id);
		$('#VehicleMileage').val(_this.vehicleViewModel.mileage);
		const vehicleDetailSectionId = _this.sections.collection.find(section => section.name === 'vehicleDetail').dom.prop('id');
		$.post(
			{
				url: '/Vehicle/GetVehiclePartial',
				data: { "vehicleRegistration": _this.vehicleViewModel.registrationNumber },
				success: function (vehiclePartial) {
					$(`#${vehicleDetailSectionId} #vehicle-model`).html('');
                    $(`#${vehicleDetailSectionId} #vehicle-model`).append(vehiclePartial);
                    if (_this.vehicleViewModel.mileageCheckSuppression) {
                        $(`#${vehicleDetailSectionId} #mileageInput`).hide();
                        $(`#${vehicleDetailSectionId} #ConfirmMileageContainer`).hide();
                    }
					if (!_this.disableMoveNext) {
						_this.sections.moveNext();
					}
				}
			});
    };    
}

// Kendo duplicating the first error message on the first error-label
function removeDuplicateErrorMessages() {
	$('i.error-icon').each(function () {
		const $icon = $(this);
		const originalTitle = $icon.attr('data-original-title');
		if (originalTitle) {
			const messages = originalTitle.split(/\s{2,}/).map(msg => msg.trim()).filter(msg => msg !== '');
			const uniqueMessages = [...new Set(messages)];
			const updatedTitle = uniqueMessages.join('  ');
			$icon.attr('data-original-title', updatedTitle);
		}
	});
}

function isValidPostcode(postcode) {
    var valid = false;

    $.ajax({
        url: `address/validpostcode?postcode=${postcode}`,
        type: 'get',
        async: false,
        success: (data, textStatus, xhr) => {
            valid = data;
        },
        error: (error) => {
            alert("Apologies something went wrong.");
            document.location.reload(true);
        }
    });

    return valid;
}

export default TyresForm;